import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";

const json = {
  1: {
    // Exercise num
    unit: "Unit 3",
    id: "FGF11-U3-P45-E2",
    audio: "Audios/bt_fpt_ai/p33_intro.mp3",
    autoPlay: true,
    video: "",
    component: MatchDots,
    exerciseKey: "img/FriendsPlus/Page33/Key/E1answerKey.png",
    titleQuestion: [
      {
        num: "1",
        title: `
        Nối mỗi góc với số đo của góc đó.
			  `,
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
          Nháy chuột vào mỗi hình rồi nháy chuột vào số đo thích hợp của góc đó để nối.
        </span>
                <video src="Audios/bt_fpt_ai/guide/p33_e1.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    stylesTextInput: { borderBottom: "10px dashed", textAlign: "center" },
    inputSize: 50,
    question: {
      DrawLines: {
        multipleLine: false,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "82px",
              left: "92px",
              width: "169px",
              height: "130px",
              // borderRadius: '50%',
              border: 0,
              background: 0,
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "82px",
              left: "282px",
              width: "169px",
              height: "130px",
              // borderRadius: '50%',
              border: 0,
              background: 0,
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "82px",
              left: "470px",
              width: "169px",
              height: "130px",
              // borderRadius: '50%',
              border: 0,
              background: 0,
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "82px",
              left: "658px",
              width: "169px",
              height: "130px",
              // borderRadius: '50%',
              border: 0,
              background: 0,
            },
          }, // A
          {
            boxMatchStyle: {
              position: "absolute",
              top: "228px",
              left: "96px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: 0,
              background: 0,
            },
          }, // B
          {
            boxMatchStyle: {
              position: "absolute",
              top: "228px",
              left: "281px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: 0,
              background: 0,
            },
          }, // C
          {
            boxMatchStyle: {
              position: "absolute",
              top: "228px",
              left: "473px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: 0,
              background: 0,
            },
          }, // D
          {
            boxMatchStyle: {
              position: "absolute",
              top: "234px",
              left: "667px",
              width: "75px",
              height: "39px",
              borderRadius: "50%",
              border: 0,
              background: 0,
            },
          }, // D
        ],
        answers: ["3-4", "2-5", "1-7", "0-6"],
        initialValue: [],
      },
      Layout: `
          <div style=' justify-content: space-around; width:800px; font-size: 26px; margin-bottom: 100px'>
          <img src='/img/FriendsPlus/Page33/E1/1.jpg' style='width: 20cm; margin-bottom: 20px;'/>
          <div style= "margin-top: 30px">
            <span style= "border: 3px solid rgb(119,177,211); border-radius: 6px; padding: 0px 12px; margin-left: 60px">90&#176;</span>
            <span style= "border: 3px solid rgb(119,177,211); border-radius: 6px; padding: 0px 12px; margin-left: 120px">60&#176;</span>
            <span style= "border: 3px solid rgb(119,177,211); border-radius: 6px; padding: 0px 12px; margin-left: 115px">180&#176;</span>
            <span style= "border: 3px solid rgb(119,177,211); border-radius: 6px; padding: 0px 12px; margin-left: 105px">120&#176;</span>
          </div>
          </div>     
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
      `,
    },
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page33/Key/E2answerKey.jpg",
    component: T6,
    isHiddenCheck: true,

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
       <span> Di chuyển thước vào các góc trong hình để đo rồi viết số đo vào chỗ chấm.</span>
                <video src="Audios/bt_fpt_ai/guide/p33_e2.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "121px",
        inputTop: "390px",
        ResultProtractor: [
          {
            textResult: 60,
            styleResult: {
              top: -196,
              left: 676,
            },
          },
          {
            textResult: 60,
            styleResult: {
              top: -40,
              left: 518,
            },
          },
          {
            textResult: 60,
            styleResult: {
              top: -147,
              left: 752,
            },
          },
          {
            textResult: 60,
            styleResult: {
              top: -140,
              left: 539,
            },
          },
          {
            textResult: 120,
            styleResult: {
              top: -144,
              left: 821,
            },
          },
          {
            textResult: 120,
            styleResult: {
              top: -30,
              left: 447,
            },
          },
        ],
        result: [
          //Đỉnh A
          {
            id: 0,
            top: -53, // top cây thước sau khi đặt vô hình
            left: 405, // left cây thước sau khi đặt vô hình
            rotate: 77,
          },
          {
            id: 1,
            top: -56, // top cây thước sau khi đặt vô hình
            left: 406, // left cây thước sau khi đặt vô hình
            rotate: -163,
          },
          //Đỉnh B
          {
            id: 2,
            top: -137, // top cây thước sau khi đặt vô hình
            left: 584, // left cây thước sau khi đặt vô hình
            rotate: 120,
          },
          {
            id: 3,
            top: -139, // top cây thước sau khi đặt vô hình
            left: 586, // left cây thước sau khi đặt vô hình
            rotate: -124,
          },
          //Đỉnh O
          {
            id: 4,
            top: 1, // top cây thước sau khi đặt vô hình
            left: 546, // left cây thước sau khi đặt vô hình
            rotate: 135,
          },
          {
            id: 5,
            top: 4, // top cây thước sau khi đặt vô hình
            left: 549, // left cây thước sau khi đặt vô hình
            rotate: -169,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "2",
        title: "Đo rồi viết số đo thích hợp vào chỗ chấm.",
        color: "rgb(99,197,244)",
      },
    ],

    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style="position: relative; top: -49px; left: 444px;">
        <img src="/img/FriendsPlus/Page33/E2/1.jpg"  style="height:10cm;margin-top:50px;position:absolute; margin-left: 89px" >
        
        
        

        <div
          style="
            position: absolute;
            left: 298px;
            top: 227px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 155px;
            top: 169px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 334px;
            top: 86px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 175px;left: 0px;width: 400px; height: 420px;z-index: 1"
        >
        <img
        src="/img/test/protractor-removebg-preview3.png"
        style="width: 400px"
        alt="image"
      />
        </div>

      <div style='width: 1000px; height: 500px;margin-bottom: 180px'>
      <div style='margin-top: 30px; line-height: 50px'>
      	<span style=''>Góc đỉnh O; cạnh OC, OD bằng <input id= "0"><sup>o</sup></span><br>
      	<span style=''>Góc đỉnh A; cạnh AC, AD bằng <input id= "1"><sup>o</sup></span><br>
      	<span style=''>Góc đỉnh B; cạnh BC, BD bằng <input id= "2"><sup>o</sup></span>
      </div>
      </div>
        `,
        answer: ["120", "60", "60"],
      },
    ],
  },

  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page33/Key/E3answerKey.png",

    titleQuestion: [
      {
        num: "3",
        title: "Khoanh vào chữ đặt trước câu trả lời đúng.",
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chữ đặt trước câu trả lời đúng.</span>
        <video src="Audios/bt_fpt_ai/guide/p33_e3.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    component: Circle_Write,
    totalInput: 1,
    Recorder: true,
    titleImage: "",
    inputSize: 70,
    questionImage: [],
    stylesTextInput: {
      textAlign: "center",
      fontSize: 23,
    },
    question: {
      Write: {
        isHiddenCheck: true,
        inputStyle: {
          width: 100,
          fontSize: 22,
          textAlign: "center",
          maxLength: 1,
          fontWeight: 700,
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          borderRadius: "50%",
          fontWeight: "bold",
          borderColor: "transparent",
          border: "2px solid white",
          padding: "0px 4px",
        },
        selectWordStyle: {
          padding: "0px 4px",
          border: "2px solid black",
        },
        limitSelect: 1,
        listWords: [
          `A &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
         B &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
         C
         `, //1
        ],
        answers: ["0-44"],
        initialValue: [],
      },
      Layout: `
        <div style= "display: flex">
          <div style= "width: 12cm">
             Mai dùng ê ke vẽ góc đỉnh O; cạnh OM, ON có số đo 90&#176, góc đỉnh O cạnh ON, OP 
             có số đo 30&#176 và góc đỉnh O cạnh OP, OQ có số đo 60&#176. <br>Hỏi góc đỉnh O; cạnh 
             OM, OQ là góc gì?
          </div>
          <img src='/img/FriendsPlus/Page33/E3/1.jpg' style= "width: 13cm; margin-left: 10px; margin-bottom: 30px; margin-top: -20px"/>
        </div>
        <div style= "margin-left: 78px; margin-top: 20px"><input id='0' type='Circle'/></div>
        <div style= "display: flex; margin-top: -38px">
          <div style = "margin-left: 109px">. Góc nhọn</div>
          <div style = "margin-left: 118px">. Góc vuông</div>
          <div style = "margin-left: 104px">. Góc bẹt</div>
        </div>
      `,
    },
  },
};

export default json;
